import React from "react";
import Label from "components/general/Label"
import Card from 'react-bootstrap/Card';
import DateTime from "components/presentation/DateTime"
import Status from "components/presentation/Status";
import { isLiveStatus, isLessLiveStatus } from "helpers/status";
import SportCode from "components/common/SportCode";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { getDateTimeFormat } from "helpers/utils";


export function Footer({ data }) {

    const formatDate = getDateTimeFormat('DayMonthShort')
    const formatDateTime = getDateTimeFormat('DayMonthShortHourMinute');
    const dateTime = data?.bi_date + ' ' + data?.bi_time
    const dateTimeFormated = data?.bi_date && <DateTime datetime={dateTime} format={formatDateTime} />
    const date = data?.bi_date && <><DateTime datetime={data?.bi_date} format={formatDate} />, <SportCode entity='@CompetitorPlace' code="TBD" abbr={true} /></>
    const time = data?.bi_time && <DateTime datetime={dateTime} format={"HH:mm"} />
    const dateComponent = data?.bi_time ? dateTimeFormated : date
    const numberGame = data?.bracketItemCode

    return (
        <>
            {isLiveStatus(data?.result?.status?.code) && <div className='score-status justify-content-end'>
                <Status typeToPrint={'result'} scheduleStatus={data?.schedule?.status?.code} resultStatus={data?.result?.status?.code} />
            </div>}
            <div className="d-flex w-100">
                {isLessLiveStatus(data?.result?.status?.code) && <div className='text-start w-50'>{dateComponent}</div>}
                {isLessLiveStatus(data?.result?.status?.code) && <div className='text-end w-50'><Label data='HeaderGame' /> {numberGame}</div>}
            </div>
        </>
    )
}

export function CompetitorBlockNoData(competitor) {
    const { mirs_discipline } = useUrlFriendlyToParameters()
    let competitorPlace = competitor?.cp_code ? <SportCode discipline={mirs_discipline} entity='@CompetitorPlace' code={competitor?.cp_code} notFound={<>&nbsp;</>} /> : ''
    let prev_value = competitor?.cp_prev_value ? <SportCode discipline={mirs_discipline} entity='@Pool' code={competitor?.cp_prev_value} abbr={true} /> : ''
    let prev_wlt = competitor?.cp_prev_wlt
    let prev_pos = <>{' ' + competitor.cp_prev_pos}</>
    return (
        <div className=' d-flex flex-row justify-content-start'>
            <div className=''>
                {prev_value && !prev_wlt
                    ? prev_value
                    : competitorPlace && !prev_wlt
                        ? competitorPlace
                        : !competitor.cp_prev_wlt
                            ? competitor?.cp_prev_pos
                            : competitor?.cp_prev_wlt === 'W'
                                ? <><Label data='HeaderWinner' /><>{prev_pos}</></>
                                : <><Label data='LabelLooserDesc' /><>{prev_pos}</></>
                }
            </div>
        </div>
    )
}

export function Header({ data, bracket, phase }) {
    return (
        <Card.Header className={data?.code !== 'CLEAN' && bracket === 'FNL' && phase === 'FNL-' ? 'visible' : 'invisible'}>
            <div className='score-header'>
                <b><span>{data?.eventUnit?.shortDescription}</span></b>
            </div>
        </Card.Header>
    )
}